import { neutralLayer1 } from '@microsoft/fast-components';
import { css } from '@microsoft/fast-element';
export const mixinScreen = (display = 'block') => `
  contain: content;
  display: ${display};
  height: 100%;
  width: 100%;
  overflow-y: auto;
`;
export const commonHostStyles = css `
  :host {
    contain: content;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    width: 100%;

    --design-unit: 3.5;
  }
`;
export const commonLoginStyles = css `
  .container {
    min-width: 330px;
    width: 15%;
    display: flex;
    flex-direction: column;
    align-items: center;

    animate: all 3s ease-in 0s;
  }

  .no-top-margin {
    margin-top: 0;
  }

  .no-top-margin::part(label) {
    margin-top: 0;
  }

  .card-pd {
    --zero-card-fill-color: #202126;
    padding: calc(var(--design-unit) * 5px);
  }

  .card-mg {
    margin: calc(var(--design-unit) * 2px);
  }

  .column-content {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .logo {
    display: initial;
    margin-bottom: calc(var(--design-unit) * 5px);
    transition: opacity 5s ease-in-out;
  }

  .heading {
    font-weight: bold;
    background-color: ${neutralLayer1};
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
    font-size: 20px;
    margin: -4px -16px 0 -16px;
    padding: 8px 16px;
  }

  .heading2 {
    font-weight: 500;
    font-size: 16px;
    text-align: center;
    opacity: 80%;
    margin-bottom: 10px;
  }

  .heading3 {
    text-align: center;
    font-weight: 500;
    font-size: 12px;
    opacity: 50%;
    margin-bottom: calc(var(--design-unit) * 5px);
  }

  form {
    display: flex;
    flex-direction: column;
  }

  .action-btn {
    margin-top: calc(var(--design-unit) * 5px);
  }

  .form-buttons {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .form-title {
    color: var(--neutral-stroke-rest);
  }

  zero-text-field {
    margin: 8px 0 12px;
  }

  zero-text-field::part(label) {
    margin-bottom: calc(var(--design-unit) * 2px);
  }

  zero-text-field,
  zero-select {
    margin-bottom: calc(var(--design-unit) * 3px);
  }

  zero-button::part(info1),
  zero-button::part(info2) {
    display: none;
  }

  zero-checkbox {
    margin-top: calc(var(--design-unit) * 3px);
  }

  zero-checkbox::part(label) {
    color: var(--neutral-stroke-rest);
  }
`;
export const commonLoginRouteStyles = css `
  ${commonHostStyles}
  ${commonLoginStyles}
`;
